// extracted by mini-css-extract-plugin
export default {"root":"Promotion_root__s7UtX","container":"Promotion_container__EviS4","logo":"Promotion_logo__sA64p","text":"Promotion_text__45ZdA"};